// Import components
import CartItem from 'components/views/offer_configurator/components/common/Basket/components/CartItem/CartItem';
import { CurrentProduct } from 'components/views/offer_configurator/components/common/Basket/components/CurrentProduct';

// Import types
import type { SummaryProduct } from 'types/views/configurator';
import type { CurrentProduct as CurrentProductType } from 'types/api/packetsSubscription/details';
import { PacketSubtype } from 'types/api/products/product';

export const renderSummaryProduct = (product: SummaryProduct) => <CartItem key={product.uuid} product={product} />;

export const renderCurrentAdditionalProduct = (product: CurrentProductType) => (
	<CurrentProduct key={product.product_uuid} subtype={PacketSubtype.Premium} product={product} />
);
